import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IOption } from '@cmps/ng-select';
import { merge, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

import { Category, DefinitionSummary } from '../insight/config.insight.model';

import { TranslationKeyMap } from './performance-insight.i18n';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function toOpts(e) {
    return {
        label: e.name,
        value: e,
    };
}

@Component({
    selector: '[cmpsPerformanceInsightCategory]',
    templateUrl: './category.pi.component.html',
})
export class CategoryPerformanceInsightComponent
    implements OnChanges, OnInit, OnDestroy
{
    @Input() summary: Category[];
    @Input() category: Category;
    @Output() categoryChange: EventEmitter<Category>;
    @Input() subCategory: Category;
    @Output() subCategoryChange: EventEmitter<Category>;
    @Input() definition: DefinitionSummary;
    @Output() definitionChange: EventEmitter<DefinitionSummary>;
    i18n = TranslationKeyMap;
    form: FormGroup;
    categoryOpts: IOption[];
    subCategoryOpts: IOption[];
    definitionOpts: IOption[];
    private _sub: Subscription;

    constructor(private readonly _formBuilder: FormBuilder) {
        this.categoryChange = new EventEmitter();
        this.subCategoryChange = new EventEmitter();
        this.definitionChange = new EventEmitter();

        this.form = this._formBuilder.group({
            category: [null],
            subCategory: [null],
            definition: [null],
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        // eslint-disable-next-line no-prototype-builtins
        if (changes.hasOwnProperty('summary')) {
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            this.categoryOpts =
                // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                this.summary && this.summary.map((e) => toOpts(e));
        }

        // eslint-disable-next-line no-prototype-builtins
        if (
            // eslint-disable-next-line no-prototype-builtins
            changes.hasOwnProperty('summary') ||
            // eslint-disable-next-line no-prototype-builtins
            changes.hasOwnProperty('category')
        ) {
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            this.subCategoryOpts =
                // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                this.category &&
                this.category.subCategories.map((e) => toOpts(e));
        }

        // eslint-disable-next-line no-prototype-builtins
        if (
            // eslint-disable-next-line no-prototype-builtins
            changes.hasOwnProperty('summary') ||
            // eslint-disable-next-line no-prototype-builtins
            changes.hasOwnProperty('category') ||
            // eslint-disable-next-line no-prototype-builtins
            changes.hasOwnProperty('subCategory')
        ) {
            const cat = this.subCategory || this.category;
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            this.definitionOpts = cat && cat.definitions.map((e) => toOpts(e));
        }

        // eslint-disable-next-line no-prototype-builtins
        if (
            // eslint-disable-next-line no-prototype-builtins
            changes.hasOwnProperty('category') ||
            // eslint-disable-next-line no-prototype-builtins
            changes.hasOwnProperty('subCategory') ||
            // eslint-disable-next-line no-prototype-builtins
            changes.hasOwnProperty('definition')
        ) {
            this.form.patchValue(
                {
                    category: [this.category],
                    subCategory: [this.subCategory],
                    definition: [this.definition],
                },
                { emitEvent: false },
            );
        }
    }

    ngOnInit(): void {
        this._sub = merge(
            this.form.get('category').valueChanges.pipe(
                tap<Category>((value) => {
                    this.subCategoryOpts = value.subCategories.map((e) =>
                        toOpts(e),
                    );
                    this.categoryChange.emit(value);
                }),
            ),
            this.form.get('subCategory').valueChanges.pipe(
                tap<Category>((value) => {
                    this.definitionOpts = value.definitions.map((e) =>
                        toOpts(e),
                    );
                    this.subCategoryChange.emit(value);
                }),
            ),
            this.form.get('definition').valueChanges.pipe(
                tap<DefinitionSummary>((value) => {
                    this.definitionChange.emit(value);
                }),
            ),
        ).subscribe();
    }

    ngOnDestroy(): void {
        if (this._sub) {
            this._sub.unsubscribe();
        }
        this.categoryChange.complete();
        this.subCategoryChange.complete();
        this.definitionChange.complete();
    }
}
